import { useMarkAsSeenNotificationMutation } from '@/types/generated/graphql';
import { cacheUpdateNotificationCount, cacheUpdateSeenNotification } from '../cache-mutation';

export const useMarkSingleAsSeen = () => {
  const [markAsSeenNotification] = useMarkAsSeenNotificationMutation({
    onCompleted: (_, clientOptions) => {
      const { notificationId } = clientOptions?.variables || {};
      cacheUpdateSeenNotification(notificationId);
      cacheUpdateNotificationCount();
    },
  });

  return {
    markAsSeenNotification,
  };
};
